<template>
    <div class="slotMachine">
        <!-- <app-wheel
            :image="productImage"
            :productName="productName"
            :variation="variation"
            :isAnimating="isAnimating"
            :threshold="threshold"
            :nrQuestions="nrQuestions"
            :thresholdCounter="thresholdCounter"
            :score="score"
        ></app-wheel> -->
        <!-- <div class="answers">
            <app-answer
                v-for="(answer, index) in answers"
                @answerWasGiven="answerWasGiven($event)"
                :id="answer.id"
                :variation="variation"
                :body="answer.name"
                :image="answer.image"
                :key="index"
                :showFeedback="isAnswered"
                :selectedID="givenAnswer"
                :correctID="correctAnswer"
                :isAnimating="isAnimating"
                :x="getX(index)"
                :y="getY(index)"
            ></app-answer>
        </div> -->
    </div>
</template>

<script>
import wheel from "./wheel.vue";

export default {
    name: "slotMachine",
    components: {
        appWheel: wheel
    },
    data() {
        return {
            // questionvariation - 0 = image in slot, 1 is text in slot.
            questionVariation: 0,
            isAnswered: false,
            givenAnswer: 0,
            correctAnswer: 0,
            answeredCorrect: false,
            answers: [],
            currentQuestion: -1,
            isAnimating: false,
            thresholdCounter: 0,
            score: 0
        };
    },
    props: {
        questionTitle: {
            type: String,
            required: false
        },
        questionBody: {
            type: String,
            required: false
        },
        questionBank: {
            type: Array,
            required: true
        },
        comparisonBank: {
            type: Array,
            required: true
        },
        timeOut: {
            type: Number,
            default: 2000
        },
        threshold: {
            type: Number,
            required: true
        },
        nrQuestions: {
            type: Number,
            required: true
        }
    },
    watch: {},
    computed: {
        answerBody() {
            return "asodiaspodas!";
        }
    },
    methods: {
        shuffle(array) {
            var j, x, i;
            for (i = array.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = array[i];
                array[i] = array[j];
                array[j] = x;
            }
            return array;
        }
    },
    mounted() {
        
    },
    beforeDestroy() {
    }
};
</script>

<style scoped>
.slotMachine {
    display: inline-block;
    width: 100%;
    height: 70%;
}
.answers {
    width: 100%;
    height: 40%;
    position: relative;
    box-sizing: border-box;
}
</style>
